// extracted by mini-css-extract-plugin
export default {"selector":"jRwsYwhrFyMKp9aLZWgU"};